<main class="chat-auth">
  <div class="card chat-auth__card mb-0">
    <div class="card-body p-4 text-center">
      <div class="auth-brand mb-3">
        <img src="assets/images/logo-dark.svg" class="logo-dark chat-auth__logo mx-auto" alt="Trendmulti" />
        <img src="assets/images/logo.svg" class="logo-light chat-auth__logo mx-auto" alt="Trendmulti" />
      </div>
      @if (!failed) {
        <div class="spinner-border text-primary my-3" role="status">
          <span class="visually-hidden">{{ 'chatApp.handoff.opening' | translate }}</span>
        </div>
        <p class="text-muted mb-0">{{ 'chatApp.handoff.opening' | translate }}</p>
      } @else {
        <div class="alert alert-warning text-start py-2" role="alert">
          <h5 class="alert-heading mt-0 mb-1"><i class="ri-error-warning-line me-1"></i>{{ 'chatApp.handoff.failedTitle' | translate }}</h5>
          <p class="mb-0">{{ 'chatApp.handoff.failedMessage' | translate }}</p>
        </div>
        <a class="btn btn-primary w-100" [href]="signInPath">{{ 'chatApp.handoff.signIn' | translate }}</a>
      }
    </div>
  </div>
</main>
